import React from 'react';
import { Box } from '@withjoy/joykit';
import { useIsFeatureEnabled } from '@shared/core/featureFlags';
import { useTravelWhiteLabelCurrency } from '@shared/hooks/useTravelWhiteLabelCurrency';
import { useQueryParamHelper } from '@shared/core/queryString';
import { TravelCurrencyCode } from '@graphql/generated';

export const IsoCurrencyIndicator: React.FC = () => {
  const currency = useTravelWhiteLabelCurrency();
  const [localeBasedCurrencyEnabled] = useIsFeatureEnabled('localeBasedHotelCurrency');
  const queryParamHelper = useQueryParamHelper();
  const showCurrencyCode = queryParamHelper.getValueString('showCurrencyCode') === 'true';

  return showCurrencyCode && currency ? <Box marginRight={2}>{localeBasedCurrencyEnabled ? currency : TravelCurrencyCode.USD}</Box> : null;
};
